import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'user-info-view',
  templateUrl: './user-info-view.component.html',
  styleUrls: ['./user-info-view.component.scss']
})
export class UserInfoViewComponent {}
